module.exports = __webpack_public_path__ + "img/header-weddingRingsTensionRings@2x.efc954e.jpg";